/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/sort-type-union-intersection-members */
/* eslint-disable @typescript-eslint/no-extra-parens */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable no-trailing-spaces */
/* eslint-disable object-curly-newline */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable object-property-newline */
import React, { useState } from 'react';
import moment from 'moment';
import ClearIcon from '@mui/icons-material/Clear';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HistoryIcon from '@mui/icons-material/History';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import EditIcon from '@mui/icons-material/Edit';
import CommentIcon from '@mui/icons-material/Comment';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MessageIcon from '@mui/icons-material/Message';
import DescriptionIcon from '@mui/icons-material/Description';
import Paper from '@mui/material/Paper';
import {
  IconButton, Tabs, Tab, Box, Button, Typography, Menu, MenuItem, ListItemIcon, ListItemText, TextField, Chip, Tooltip,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useMutation, useQueryClient } from 'react-query';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { formatTenantName } from 'utils/formatTenantName';
import type { ROFRMonitorItem, ActivityEntry, ActivityType, OptionStatus } from './types';
import {
  OPTION_TYPE_CONFIG,
  OPTION_STATUS_CONFIG,
  ALL_OPTION_STATUSES,
} from './types';
import LeaseAbstractionTab from './LeaseAbstractionTab';
import AmendmentAbstractionTab from './AmendmentAbstractionTab';

const RATE_STRUCTURE_LABELS: Record<string, string> = {
  fmv: 'FMV',
  fixed: 'Fixed',
  cpi: 'CPI',
};

interface OptionsDetailSideSheetProps {
  item: ROFRMonitorItem;
  onClose: () => void;
  isClosing: boolean;
  pendingStatusFromTable?: OptionStatus | null;
}

interface TabPanelProps {
  index: number;
  value: number;
  children: React.ReactNode;
}

function TabPanel(props: TabPanelProps): JSX.Element {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`options-tabpanel-${index}`}
      aria-labelledby={`options-tab-${index}`}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      style={{ height: 'calc(100% - 48px)', overflow: 'auto' }}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

export default function OptionsDetailSideSheet({ item, onClose, isClosing, pendingStatusFromTable }: OptionsDetailSideSheetProps): JSX.Element {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [statusMenuAnchor, setStatusMenuAnchor] = useState<HTMLElement | null>(null);
  
  // State for note prompt when changing to Waived/Exercised
  // Initialize from pendingStatusFromTable if provided (from table status click)
  const [pendingStatus, setPendingStatus] = useState<OptionStatus | null>(pendingStatusFromTable || null);
  const [showNotePrompt, setShowNotePrompt] = useState(Boolean(pendingStatusFromTable));
  
  // Sync pendingStatus when pendingStatusFromTable prop changes (e.g., from table status dropdown)
  React.useEffect(() => {
    if (pendingStatusFromTable) {
      setPendingStatus(pendingStatusFromTable);
      setShowNotePrompt(true);
    }
  }, [pendingStatusFromTable]);
  const [promptNoteValue, setPromptNoteValue] = useState('');
  
  // State for editing existing status note
  const [isEditingNote, setIsEditingNote] = useState(false);
  const [editNoteValue, setEditNoteValue] = useState(item.status_note || '');

  // State for editing unit/suite
  const [isEditingUnitSuite, setIsEditingUnitSuite] = useState(false);
  const [editUnitSuiteValue, setEditUnitSuiteValue] = useState(item.unit_suite || '');

  // State for editing tenant name
  const [isEditingTenantName, setIsEditingTenantName] = useState(false);
  const [editTenantNameValue, setEditTenantNameValue] = useState(item.tenant_name || '');

  // State for editing trigger event
  const [isEditingTriggerEvent, setIsEditingTriggerEvent] = useState(false);
  const [editTriggerEventValue, setEditTriggerEventValue] = useState(item.trigger_event || '');

  // State for editing SF
  const [isEditingSF, setIsEditingSF] = useState(false);
  const [editSFValue, setEditSFValue] = useState(item.tenant_sqft ? String(item.tenant_sqft) : '');

  // State for rate structure dropdown
  const [rateStructureMenuAnchor, setRateStructureMenuAnchor] = useState<HTMLElement | null>(null);

  // State for editing notice period
  const [isEditingNoticePeriod, setIsEditingNoticePeriod] = useState(false);
  const [editNoticePeriodValue, setEditNoticePeriodValue] = useState(item.notice_period || '');

  // State for editing lease expiration
  const [isEditingLeaseExpiration, setIsEditingLeaseExpiration] = useState(false);
  const [editLeaseExpirationValue, setEditLeaseExpirationValue] = useState(
    item.lease_expiration_date ? item.lease_expiration_date.split('T')[0] : '',
  );

  // Mutation to update option status with note
  const { mutate: updateOptionStatus, isLoading: isUpdatingStatus } = useMutation(
    async ({ id, status, note }: { id: number; status: OptionStatus; note?: string }) => axios({
      url: `/api/options-monitor/${id}/update_status/`,
      method: 'post',
      data: { option_status: status.toLowerCase(), note: note || '' },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Status updated successfully');
        setStatusMenuAnchor(null);
        setShowNotePrompt(false);
        setPendingStatus(null);
        setPromptNoteValue('');
      },
      onError: () => {
        enqueueSnackbar('Failed to update status', { variant: 'error' });
      },
    },
  );

  // Mutation to update just the note
  const { mutate: updateNote, isLoading: isUpdatingNote } = useMutation(
    async ({ id, note }: { id: number; note: string }) => axios({
      url: `/api/options-monitor/${id}/update_note/`,
      method: 'post',
      data: { note },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Note updated successfully');
        setIsEditingNote(false);
      },
      onError: () => {
        enqueueSnackbar('Failed to update note', { variant: 'error' });
      },
    },
  );

  // Mutation to update unit/suite
  const { mutate: updateUnitSuite, isLoading: isUpdatingUnitSuite } = useMutation(
    async ({ id, unitSuite }: { id: number; unitSuite: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { unit_suite: unitSuite },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Unit / Suite updated');
        setIsEditingUnitSuite(false);
      },
      onError: () => {
        enqueueSnackbar('Failed to update unit / suite', { variant: 'error' });
      },
    },
  );

  // Mutation to update tenant name (propagates to the linked lease)
  const { mutate: updateTenantName, isLoading: isUpdatingTenantName } = useMutation(
    async ({ id, tenantName }: { id: number; tenantName: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { tenant_name: tenantName },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        await queryClient.invalidateQueries('get/leases');
        enqueueSnackbar('Tenant name updated');
        setIsEditingTenantName(false);
      },
      onError: () => {
        enqueueSnackbar('Failed to update tenant name', { variant: 'error' });
        setIsEditingTenantName(false);
      },
    },
  );

  // Mutation: update trigger event
  const { mutate: updateTriggerEvent, isLoading: isUpdatingTriggerEvent } = useMutation(
    async ({ id, triggerEvent }: { id: number; triggerEvent: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { trigger_event: triggerEvent },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Trigger event updated');
        setIsEditingTriggerEvent(false);
      },
      onError: () => { enqueueSnackbar('Failed to update trigger event', { variant: 'error' }); },
    },
  );

  // Mutation: update SF
  const { mutate: updateSF, isLoading: isUpdatingSF } = useMutation(
    async ({ id, tenantSqft }: { id: number; tenantSqft: number | null }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { tenant_sqft: tenantSqft },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('SF updated');
        setIsEditingSF(false);
      },
      onError: () => { enqueueSnackbar('Failed to update SF', { variant: 'error' }); },
    },
  );

  // Mutation: update rate structure
  const { mutate: updateRateStructure } = useMutation(
    async ({ id, rateStructure }: { id: number; rateStructure: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { rate_structure: rateStructure },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Rate structure updated');
        setRateStructureMenuAnchor(null);
      },
      onError: () => { enqueueSnackbar('Failed to update rate structure', { variant: 'error' }); },
    },
  );

  // Mutation: update notice period
  const { mutate: updateNoticePeriod, isLoading: isUpdatingNoticePeriod } = useMutation(
    async ({ id, noticePeriod }: { id: number; noticePeriod: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { notice_period: noticePeriod },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Notice period updated');
        setIsEditingNoticePeriod(false);
      },
      onError: () => { enqueueSnackbar('Failed to update notice period', { variant: 'error' }); },
    },
  );

  // Mutation: update lease expiration
  const { mutate: updateLeaseExpiration, isLoading: isUpdatingLeaseExpiration } = useMutation(
    async ({ id, leaseExpirationDate }: { id: number; leaseExpirationDate: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { lease_expiration_date: leaseExpirationDate },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Lease expiration updated');
        setIsEditingLeaseExpiration(false);
      },
      onError: () => { enqueueSnackbar('Failed to update lease expiration', { variant: 'error' }); },
    },
  );

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number): void => {
    setTabValue(newValue);
  };

  const handleStatusClick = (event: React.MouseEvent<HTMLElement>): void => {
    setStatusMenuAnchor(event.currentTarget);
  };

  const handleStatusClose = (): void => {
    setStatusMenuAnchor(null);
  };

  const handleStatusChange = (newStatus: OptionStatus): void => {
    if (newStatus === 'Waived' || newStatus === 'Exercised') {
      // Show note prompt for Waived/Exercised
      setPendingStatus(newStatus);
      setShowNotePrompt(true);
      setPromptNoteValue('');
      setStatusMenuAnchor(null);
    } else {
      // Direct change for Active (reactivate)
      updateOptionStatus({ id: item.id, status: newStatus });
    }
  };

  const confirmStatusWithNote = (): void => {
    if (pendingStatus) {
      updateOptionStatus({ id: item.id, status: pendingStatus, note: promptNoteValue });
    }
  };

  const cancelStatusChange = (): void => {
    setShowNotePrompt(false);
    setPendingStatus(null);
    setPromptNoteValue('');
  };

  const handleMarkAsWaived = (): void => {
    handleStatusChange('Waived');
  };

  const handleMarkAsExercised = (): void => {
    handleStatusChange('Exercised');
  };

  const handleSaveNote = (): void => {
    updateNote({ id: item.id, note: editNoteValue });
  };

  const handleCancelEditNote = (): void => {
    setIsEditingNote(false);
    setEditNoteValue(item.status_note || '');
  };

  const handleSaveUnitSuite = (): void => {
    updateUnitSuite({ id: item.id, unitSuite: editUnitSuiteValue });
  };

  const handleCancelEditUnitSuite = (): void => {
    setIsEditingUnitSuite(false);
    setEditUnitSuiteValue(item.unit_suite || '');
  };

  const handleSaveTenantName = (): void => {
    const trimmed = editTenantNameValue.trim();
    if (trimmed) updateTenantName({ id: item.id, tenantName: trimmed });
    else setIsEditingTenantName(false);
  };

  const handleCancelEditTenantName = (): void => {
    setIsEditingTenantName(false);
    setEditTenantNameValue(item.tenant_name || '');
  };

  const handleSaveTriggerEvent = (): void => {
    updateTriggerEvent({ id: item.id, triggerEvent: editTriggerEventValue });
  };
  const handleCancelEditTriggerEvent = (): void => {
    setIsEditingTriggerEvent(false);
    setEditTriggerEventValue(item.trigger_event || '');
  };

  const handleSaveSF = (): void => {
    const digits = editSFValue.replace(/[^0-9]/g, '');
    updateSF({ id: item.id, tenantSqft: digits ? parseInt(digits, 10) : null });
  };
  const handleCancelEditSF = (): void => {
    setIsEditingSF(false);
    setEditSFValue(item.tenant_sqft ? String(item.tenant_sqft) : '');
  };

  const handleSaveNoticePeriod = (): void => {
    updateNoticePeriod({ id: item.id, noticePeriod: editNoticePeriodValue });
  };
  const handleCancelEditNoticePeriod = (): void => {
    setIsEditingNoticePeriod(false);
    setEditNoticePeriodValue(item.notice_period || '');
  };

  const handleSaveLeaseExpiration = (): void => {
    updateLeaseExpiration({ id: item.id, leaseExpirationDate: editLeaseExpirationValue });
  };
  const handleCancelEditLeaseExpiration = (): void => {
    setIsEditingLeaseExpiration(false);
    setEditLeaseExpirationValue(item.lease_expiration_date ? item.lease_expiration_date.split('T')[0] : '');
  };

  const handleViewLease = (): void => {
    if (item.pdf_url) {
      const baseUrl = process.env.REACT_APP_BASE_URL ?? '';
      const fullUrl = item.pdf_url.startsWith('http') ? item.pdf_url : `${baseUrl}${item.pdf_url}`;
      window.open(fullUrl, '_blank');
    } else {
      navigate(`/workspace/leases/${item.lease_id}`);
    }
  };

  // When pending status exists (waiting for note confirmation), show that; otherwise show actual status
  const displayStatus = pendingStatus || (item.option_status as OptionStatus) || 'Active';
  const currentStatus = (item.option_status as OptionStatus) || 'Active';
  const statusConfig = OPTION_STATUS_CONFIG[displayStatus] || OPTION_STATUS_CONFIG.Active;
  const optionTypeConfig = item.option_type ? (OPTION_TYPE_CONFIG[item.option_type] || OPTION_TYPE_CONFIG.ROFR) : null;

  return (
    <Paper className={`options-detail-sidesheet${isClosing ? ' closing' : ''}`}>
      {/* Header - Simplified */}
      <div className='sidesheet-header-simple'>
        <div className='header-top-row'>
          {isEditingTenantName ? (
            <Box display='flex' alignItems='center' gap={0.5} flex={1} mr={1}>
              <TextField
                size='small'
                value={editTenantNameValue}
                onChange={(e): void => { setEditTenantNameValue(e.target.value); }}
                onKeyDown={(e): void => {
                  if (e.key === 'Enter') handleSaveTenantName();
                  else if (e.key === 'Escape') handleCancelEditTenantName();
                }}
                autoFocus
                placeholder='Enter tenant name'
                sx={{
                  flex: 1,
                  '& .MuiInputBase-input': { fontSize: '18px', fontWeight: 700, padding: '4px 8px' },
                  '& .MuiOutlinedInput-root': { borderRadius: '4px' },
                }}
              />
              <IconButton size='small' onClick={handleSaveTenantName} disabled={isUpdatingTenantName} sx={{ color: '#00CFA1' }}>
                <CheckIcon sx={{ fontSize: 16 }} />
              </IconButton>
              <IconButton size='small' onClick={handleCancelEditTenantName} sx={{ color: '#6B7280' }}>
                <ClearIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Box>
          ) : (
            <h2
              className='tenant-name-large'
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}
              onClick={(): void => { setIsEditingTenantName(true); setEditTenantNameValue(item.tenant_name || ''); }}
              aria-hidden='true'
            >
              {formatTenantName(item.tenant_name)}
              <EditIcon sx={{ fontSize: 14, color: '#9CA3AF', opacity: 0.6 }} />
            </h2>
          )}
          <IconButton onClick={onClose} size='small' className='close-btn'>
            <ClearIcon />
          </IconButton>
        </div>

        {/* Option Type Badge + Status Toggle */}
        <div className='badges-row'>
          {optionTypeConfig ? (
            <span
              className='option-type-badge-large'
              style={{
                backgroundColor: optionTypeConfig.bgColor,
                color: optionTypeConfig.color,
                border: `1px solid ${optionTypeConfig.borderColor}`,
              }}
            >
              {optionTypeConfig.label}
            </span>
          ) : (
            <span
              className='option-type-badge-large'
              style={{
                backgroundColor: '#F3F4F6',
                color: '#6B7280',
                border: '1px solid #E5E7EB',
              }}
            >
              No Option
            </span>
          )}
          <div
            className='status-toggle'
            onClick={handleStatusClick}
            aria-hidden='true'
            style={{
              backgroundColor: statusConfig.bgColor,
              color: statusConfig.color,
              border: `1px solid ${statusConfig.borderColor}`,
            }}
          >
            {statusConfig.label}
            {pendingStatus && <span style={{ fontSize: '10px', marginLeft: '4px' }}>(pending)</span>}
            <KeyboardArrowDownIcon sx={{ fontSize: 16, ml: 0.5 }} />
          </div>
          <Menu
            anchorEl={statusMenuAnchor}
            open={Boolean(statusMenuAnchor)}
            onClose={handleStatusClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            PaperProps={{ style: { minWidth: '120px', marginTop: '4px' } }}
          >
            {ALL_OPTION_STATUSES.map((s) => {
              const sConfig = OPTION_STATUS_CONFIG[s];
              return (
                <MenuItem
                  key={s}
                  onClick={(): void => { handleStatusChange(s); }}
                  selected={s === displayStatus}
                >
                  <ListItemIcon>
                    {s === displayStatus && <CheckIcon style={{ fontSize: '16px', color: '#212121' }} />}
                  </ListItemIcon>
                  <ListItemText primary={sConfig.label} />
                </MenuItem>
              );
            })}
          </Menu>
        </div>

        {/* Action Status Banner */}
        {item.action_status && (
          <div style={{
            padding: '8px 12px',
            borderRadius: '6px',
            backgroundColor: item.action_status.color_tier === 'critical' ? '#FDEDED'
              : item.action_status.color_tier === 'overdue' ? '#FDEDED'
              : item.action_status.color_tier === 'warning' ? '#FFF3E0'
              : item.action_status.color_tier === 'safe' ? '#FDF8E8'
              : '#F3F4F6',
            marginTop: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}>
            <span style={{
              width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0,
              backgroundColor: {
                safe: '#D4A017', warning: '#E67E22', critical: '#C0392B',
                overdue: '#8B0000', neutral: '#9CA3AF', muted: '#D1D5DB',
              }[item.action_status.color_tier] || '#9CA3AF',
            }} />
            <span style={{
              fontWeight: 500,
              fontSize: '13px',
              color: {
                safe: '#D4A017', warning: '#E67E22', critical: '#C0392B',
                overdue: '#8B0000', neutral: '#6B7280', muted: '#9CA3AF',
              }[item.action_status.color_tier] || '#6B7280',
            }}>
              {item.action_status.label}
            </span>
          </div>
        )}

        {/* Last Updated + Status Changed By */}
        <div className='last-updated-row'>
          <AccessTimeIcon sx={{ fontSize: 14, color: '#6B7280' }} />
          <span className='last-updated-text'>
            Last updated
            {' '}
            {item.modified
              ? new Date(item.modified).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
              : 'N/A'}
          </span>
          {item.status_changed_by && (
            <>
              <span className='separator'>|</span>
              <span className='status-changed-text'>
                Status set by
                {' '}
                <strong>{item.status_changed_by.name}</strong>
                {' '}
                on
                {' '}
                {item.status_changed_by.timestamp}
              </span>
            </>
          )}
        </div>
      </div>

      {/* Note Prompt (inline) - shows when changing to Waived/Exercised */}
      {showNotePrompt && (
        <Box
          sx={{
            backgroundColor: '#F9FAFB',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            p: 2,
            mx: 2,
            mt: 1,
          }}
        >
          <Typography variant='body2' fontWeight={500} color='#374151' mb={1}>
            Mark as {pendingStatus}
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={2}
            placeholder="Add a note (optional) — e.g., 'Tenant declined via email'"
            value={promptNoteValue}
            onChange={(e): void => setPromptNoteValue(e.target.value)}
            size='small'
            sx={{
              '& .MuiOutlinedInput-root': {
                fontSize: '14px',
              },
            }}
          />
          <Box display='flex' justifyContent='flex-end' gap={1} mt={1.5}>
            <Button
              variant='outlined'
              size='small'
              onClick={cancelStatusChange}
              sx={{
                borderColor: '#E5E7EB',
                color: '#374151',
                textTransform: 'none',
                fontSize: '13px',
                '&:hover': { borderColor: '#9CA3AF', backgroundColor: '#F9FAFB' },
              }}
            >
              Cancel
            </Button>
            <Button
              variant='contained'
              size='small'
              onClick={confirmStatusWithNote}
              disabled={isUpdatingStatus}
              sx={{
                backgroundColor: '#00CFA1',
                color: '#fff',
                textTransform: 'none',
                fontSize: '13px',
                boxShadow: 'none',
                '&:hover': { backgroundColor: '#00B890', boxShadow: 'none' },
              }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      )}

      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label='Option detail tabs'
          sx={{
            '& .MuiTab-root': { textTransform: 'none', fontWeight: 500, fontSize: '14px' },
            '& .Mui-selected': { color: '#00CFA1' },
            '& .MuiTabs-indicator': { backgroundColor: '#00CFA1' },
          }}
        >
          <Tab label='Option Details' id='options-tab-0' aria-controls='options-tabpanel-0' />
          <Tab label='Full Lease Abstraction' id='options-tab-1' aria-controls='options-tabpanel-1' />
          <Tab label='Amendments' id='options-tab-2' aria-controls='options-tabpanel-2' />
        </Tabs>
      </Box>

      {/* Tab 1: Option Details */}
      <TabPanel value={tabValue} index={0}>
        <div className='option-details-content'>
          {/* Status Note Display/Edit - only shows when there's a note */}
          {item.status_note && (
            <Box
              sx={{
                backgroundColor: 'rgba(245, 158, 11, 0.08)',
                border: '1px solid rgba(245, 158, 11, 0.2)',
                borderRadius: '8px',
                p: 1.5,
                mb: 2,
              }}
            >
              <Box display='flex' alignItems='flex-start' justifyContent='space-between' gap={1}>
                <Box display='flex' alignItems='flex-start' gap={1} flex={1}>
                  <MessageIcon sx={{ fontSize: 16, color: '#D97706', mt: 0.25, flexShrink: 0 }} />
                  <Box flex={1}>
                    <Typography variant='caption' fontWeight={500} color='#B45309' display='block' mb={0.5}>
                      Status Note
                    </Typography>
                    {isEditingNote ? (
                      <Box>
                        <TextField
                          fullWidth
                          multiline
                          rows={2}
                          value={editNoteValue}
                          onChange={(e): void => setEditNoteValue(e.target.value)}
                          placeholder='Add a note about this status...'
                          size='small'
                          sx={{
                            mb: 1,
                            backgroundColor: '#fff',
                            '& .MuiOutlinedInput-root': { fontSize: '14px' },
                          }}
                        />
                        <Box display='flex' gap={1}>
                          <Button
                            size='small'
                            onClick={handleSaveNote}
                            disabled={isUpdatingNote}
                            sx={{
                              backgroundColor: '#00CFA1',
                              color: '#fff',
                              textTransform: 'none',
                              fontSize: '12px',
                              py: 0.5,
                              '&:hover': { backgroundColor: '#00B890' },
                            }}
                          >
                            Save
                          </Button>
                          <Button
                            size='small'
                            variant='text'
                            onClick={handleCancelEditNote}
                            sx={{
                              color: '#6B7280',
                              textTransform: 'none',
                              fontSize: '12px',
                              py: 0.5,
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </Box>
                    ) : (
                      <Typography variant='body2' color='#92400E'>
                        {item.status_note || <em style={{ color: '#D97706' }}>No note added</em>}
                      </Typography>
                    )}
                  </Box>
                </Box>
                {!isEditingNote && (
                  <IconButton
                    size='small'
                    onClick={(): void => { setIsEditingNote(true); setEditNoteValue(item.status_note || ''); }}
                    sx={{
                      color: '#D97706',
                      '&:hover': { backgroundColor: 'rgba(245, 158, 11, 0.1)' },
                    }}
                  >
                    <EditIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                )}
              </Box>
            </Box>
          )}

          {/* Lease Reference - opens PDF in new tab */}
          {(item.lease_reference || item.page_number || item.pdf_url) && (
            <div className='detail-section'>
              <h4 className='section-label'>Lease Reference</h4>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Button
                  variant='text'
                  onClick={(): void => {
                    if (item.pdf_url) {
                      // Use backend URL for media files, not frontend
                      const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:8000';
                      // Strip any existing hash from pdf_url before adding page
                      const cleanPdfUrl = item.pdf_url.split('#')[0];
                      const fullPdfUrl = cleanPdfUrl.startsWith('http') 
                        ? cleanPdfUrl 
                        : `${baseUrl}${cleanPdfUrl}`;
                      const pdfUrl = item.page_number 
                        ? `${fullPdfUrl}#page=${item.page_number}`
                        : fullPdfUrl;
                      window.open(pdfUrl, '_blank');
                    }
                  }}
                  disabled={!item.pdf_url}
                  sx={{
                    textTransform: 'none',
                    color: '#21B573',
                    p: 0,
                    minWidth: 'auto',
                    justifyContent: 'flex-start',
                    '&:hover': {
                      backgroundColor: 'transparent',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  {item.lease_reference || (item.page_number ? `Page ${item.page_number}` : 'View Lease Document')}
                </Button>
                {item.source_document_name && (
                  <Chip
                    label={`From: ${item.source_document_name}`}
                    size='small'
                    sx={{
                      fontSize: '11px',
                      fontFamily: 'Roboto',
                      height: '22px',
                      backgroundColor: 'rgba(33, 181, 115, 0.1)',
                      color: '#21B573',
                      border: '1px solid rgba(33, 181, 115, 0.2)',
                    }}
                  />
                )}
              </Box>
            </div>
          )}

          {/* Clause Excerpt */}
          {item.clause_excerpt && (
            <div className='detail-section'>
              <h4 className='section-label'>Clause Excerpt</h4>
              <div className='clause-excerpt-box'>
                &quot;{item.clause_excerpt}&quot;
              </div>
            </div>
          )}

          {/* Details Grid */}
          <div className='details-grid'>
            <div className='detail-item'>
              <span className='detail-label'>BUILDING</span>
              <span className='detail-value'>{item.property_name || '-'}</span>
            </div>
            <div className='detail-item'>
              <span className='detail-label'>UNIT / SUITE</span>
              {isEditingUnitSuite ? (
                <Box display='flex' alignItems='center' gap={0.5}>
                  <TextField
                    size='small'
                    value={editUnitSuiteValue}
                    onChange={(e): void => setEditUnitSuiteValue(e.target.value)}
                    onKeyDown={(e): void => {
                      if (e.key === 'Enter') handleSaveUnitSuite();
                      else if (e.key === 'Escape') handleCancelEditUnitSuite();
                    }}
                    autoFocus
                    placeholder='Enter unit / suite'
                    sx={{
                      flex: 1,
                      '& .MuiInputBase-input': { fontSize: '13px', padding: '4px 8px' },
                      '& .MuiOutlinedInput-root': { borderRadius: '4px' },
                    }}
                  />
                  <IconButton size='small' onClick={handleSaveUnitSuite} disabled={isUpdatingUnitSuite} sx={{ color: '#00CFA1' }}>
                    <CheckIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                  <IconButton size='small' onClick={handleCancelEditUnitSuite} sx={{ color: '#6B7280' }}>
                    <ClearIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              ) : (
                <span
                  className='detail-value'
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                  onClick={(): void => { setIsEditingUnitSuite(true); setEditUnitSuiteValue(item.unit_suite || ''); }}
                  aria-hidden='true'
                >
                  {item.unit_suite || <span style={{ color: '#9CA3AF', fontStyle: 'italic' }}>Click to add</span>}
                  <EditIcon sx={{ fontSize: 14, color: '#9CA3AF', opacity: 0.6 }} />
                </span>
              )}
            </div>
            <div className='detail-item'>
              <span className='detail-label'>APPLIES TO</span>
              <span className='detail-value'>
                {item.applies_to ? item.applies_to.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase()) : '-'}
              </span>
            </div>
            <div className='detail-item'>
              <span className='detail-label'>TRIGGER EVENT</span>
              {isEditingTriggerEvent ? (
                <Box display='flex' alignItems='flex-start' gap={0.5}>
                  <TextField
                    size='small'
                    multiline
                    minRows={2}
                    maxRows={10}
                    value={editTriggerEventValue}
                    onChange={(e): void => setEditTriggerEventValue(e.target.value)}
                    onKeyDown={(e): void => {
                      if (e.key === 'Escape') handleCancelEditTriggerEvent();
                    }}
                    autoFocus
                    placeholder='Enter trigger event'
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': { borderRadius: '4px', padding: '4px 6px' },
                      '& .MuiInputBase-input': { fontSize: '13px', padding: 0 },
                    }}
                  />
                  <IconButton size='small' onClick={handleSaveTriggerEvent} disabled={isUpdatingTriggerEvent} sx={{ color: '#00CFA1' }}>
                    <CheckIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                  <IconButton size='small' onClick={handleCancelEditTriggerEvent} sx={{ color: '#6B7280' }}>
                    <ClearIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              ) : (
                <span
                  className='detail-value'
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                  onClick={(): void => { setIsEditingTriggerEvent(true); setEditTriggerEventValue(item.trigger_event || ''); }}
                  aria-hidden='true'
                >
                  {item.trigger_event || <span style={{ color: '#9CA3AF', fontStyle: 'italic' }}>Click to add</span>}
                  <EditIcon sx={{ fontSize: 14, color: '#9CA3AF', opacity: 0.6 }} />
                </span>
              )}
            </div>
            <div className='detail-item'>
              <span className='detail-label'>SF</span>
              {isEditingSF ? (
                <Box display='flex' alignItems='center' gap={0.5}>
                  <TextField
                    size='small'
                    value={editSFValue}
                    onChange={(e): void => setEditSFValue(e.target.value.replace(/[^0-9]/g, ''))}
                    onKeyDown={(e): void => {
                      if (e.key === 'Enter') handleSaveSF();
                      else if (e.key === 'Escape') handleCancelEditSF();
                    }}
                    autoFocus
                    placeholder='Enter SF'
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    sx={{
                      flex: 1,
                      '& .MuiInputBase-input': { fontSize: '13px', padding: '4px 8px' },
                      '& .MuiOutlinedInput-root': { borderRadius: '4px' },
                    }}
                  />
                  <IconButton size='small' onClick={handleSaveSF} disabled={isUpdatingSF} sx={{ color: '#00CFA1' }}>
                    <CheckIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                  <IconButton size='small' onClick={handleCancelEditSF} sx={{ color: '#6B7280' }}>
                    <ClearIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              ) : (
                <span
                  className='detail-value'
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                  onClick={(): void => { setIsEditingSF(true); setEditSFValue(item.tenant_sqft ? String(item.tenant_sqft) : ''); }}
                  aria-hidden='true'
                >
                  {item.tenant_sqft
                    ? item.tenant_sqft.toLocaleString()
                    : <span style={{ color: '#9CA3AF', fontStyle: 'italic' }}>Click to add</span>}
                  <EditIcon sx={{ fontSize: 14, color: '#9CA3AF', opacity: 0.6 }} />
                </span>
              )}
            </div>
            <div className='detail-item'>
              <span className='detail-label'>RATE STRUCTURE</span>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{ display: 'inline-flex', alignItems: 'center', gap: '2px', cursor: 'pointer', color: item.rate_structure ? '#212121' : '#9CA3AF' }}
                  onClick={(e: React.MouseEvent<HTMLElement>): void => { setRateStructureMenuAnchor(e.currentTarget); }}
                  aria-hidden='true'
                >
                  <span className='detail-value' style={{ fontStyle: item.rate_structure ? 'normal' : 'italic' }}>
                    {item.rate_structure ? (RATE_STRUCTURE_LABELS[item.rate_structure] ?? item.rate_structure) : 'Select'}
                  </span>
                  <KeyboardArrowDownIcon sx={{ fontSize: 14, color: '#9CA3AF' }} />
                </div>
                <Menu
                  anchorEl={rateStructureMenuAnchor}
                  open={Boolean(rateStructureMenuAnchor)}
                  onClose={(): void => { setRateStructureMenuAnchor(null); }}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  PaperProps={{ style: { minWidth: '100px', marginTop: '4px' } }}
                >
                  {(['fmv', 'fixed', 'cpi'] as const).map((rs) => (
                    <MenuItem key={rs} onClick={(): void => { updateRateStructure({ id: item.id, rateStructure: rs }); }}>
                      <ListItemIcon sx={{ minWidth: '28px' }}>
                        {item.rate_structure === rs && <CheckIcon style={{ fontSize: '16px', color: '#212121' }} />}
                      </ListItemIcon>
                      <ListItemText primary={RATE_STRUCTURE_LABELS[rs]} />
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            </div>
            <div className='detail-item'>
              <span className='detail-label'>NOTICE PERIOD</span>
              {isEditingNoticePeriod ? (
                <Box display='flex' alignItems='center' gap={0.5}>
                  <TextField
                    size='small'
                    value={editNoticePeriodValue}
                    onChange={(e): void => setEditNoticePeriodValue(e.target.value)}
                    onKeyDown={(e): void => {
                      if (e.key === 'Enter') handleSaveNoticePeriod();
                      else if (e.key === 'Escape') handleCancelEditNoticePeriod();
                    }}
                    autoFocus
                    placeholder='e.g. 30 days, 90 days'
                    sx={{
                      flex: 1,
                      '& .MuiInputBase-input': { fontSize: '13px', padding: '4px 8px' },
                      '& .MuiOutlinedInput-root': { borderRadius: '4px' },
                    }}
                  />
                  <IconButton size='small' onClick={handleSaveNoticePeriod} disabled={isUpdatingNoticePeriod} sx={{ color: '#00CFA1' }}>
                    <CheckIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                  <IconButton size='small' onClick={handleCancelEditNoticePeriod} sx={{ color: '#6B7280' }}>
                    <ClearIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              ) : (
                <Tooltip
                  title='Enter number of days (e.g. 30 days, 90 days) so Action Status can be calculated'
                  placement='top'
                  componentsProps={{ tooltip: { sx: { maxWidth: 240, fontSize: '12px' } } }}
                >
                  <span
                    className='detail-value'
                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                    onClick={(): void => { setIsEditingNoticePeriod(true); setEditNoticePeriodValue(item.notice_period?.toLowerCase() === 'null' ? '' : (item.notice_period || '')); }}
                    aria-hidden='true'
                  >
                    {item.notice_period && item.notice_period.toLowerCase() !== 'null'
                      ? item.notice_period.charAt(0).toUpperCase() + item.notice_period.slice(1)
                      : <span style={{ color: '#9CA3AF', fontStyle: 'italic' }}>Click to add</span>}
                    <EditIcon sx={{ fontSize: 14, color: '#9CA3AF', opacity: 0.6 }} />
                  </span>
                </Tooltip>
              )}
            </div>
            <div className='detail-item'>
              <span className='detail-label'>LEASE EXPIRATION</span>
              {isEditingLeaseExpiration ? (
                <Box display='flex' alignItems='center' gap={0.5}>
                  <TextField
                    size='small'
                    type='date'
                    value={editLeaseExpirationValue}
                    onChange={(e): void => setEditLeaseExpirationValue(e.target.value)}
                    onKeyDown={(e): void => {
                      if (e.key === 'Enter') handleSaveLeaseExpiration();
                      else if (e.key === 'Escape') handleCancelEditLeaseExpiration();
                    }}
                    autoFocus
                    sx={{
                      flex: 1,
                      '& .MuiInputBase-input': { fontSize: '13px', padding: '4px 8px' },
                      '& .MuiOutlinedInput-root': { borderRadius: '4px' },
                    }}
                  />
                  <IconButton size='small' onClick={handleSaveLeaseExpiration} disabled={isUpdatingLeaseExpiration} sx={{ color: '#00CFA1' }}>
                    <CheckIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                  <IconButton size='small' onClick={handleCancelEditLeaseExpiration} sx={{ color: '#6B7280' }}>
                    <ClearIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              ) : (
                <span
                  className='detail-value'
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                  onClick={(): void => { setIsEditingLeaseExpiration(true); setEditLeaseExpirationValue(item.lease_expiration_date ? item.lease_expiration_date.split('T')[0] : ''); }}
                  aria-hidden='true'
                >
                  {item.lease_expiration_date
                    ? moment(item.lease_expiration_date).format('MMMM D, YYYY')
                    : <span style={{ color: '#9CA3AF', fontStyle: 'italic' }}>—</span>}
                  <EditIcon sx={{ fontSize: 14, color: '#9CA3AF', opacity: 0.6 }} />
                </span>
              )}
            </div>
            <div className='detail-item'>
              <span className='detail-label'>NOTICE DATE</span>
              <span className='detail-value'>
                {item.notice_date
                  ? moment(item.notice_date).format('MMMM D, YYYY')
                  : '—'}
              </span>
            </div>
            <div className='detail-item'>
              <span className='detail-label'>VERIFIED BY</span>
              <span className='detail-value'>
                {item.verified_by ? (
                  <>
                    {item.verified_by.full_name || item.verified_by.name}
                    <span className='verified-date'>
                      {item.last_verified && new Date(item.last_verified).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </span>
                  </>
                ) : '-'}
              </span>
            </div>
          </div>

          {/* Activity History */}
          <div className='activity-section'>
            <h4 className='section-label'>ACTIVITY HISTORY</h4>
            {(!item.activity_history || item.activity_history.length === 0) ? (
              <div className='no-activity-message'>
                No activity recorded yet
              </div>
            ) : (
              <div className='activity-list'>
                {item.activity_history.map((activity: ActivityEntry, index: number) => {
                  // Handle both backend (activity_type) and legacy (type) formats
                  const activityType = activity.activity_type || activity.type || '';
                  const userName = activity.user_name || activity.user || 'Unknown';
                  
                  const getActivityIcon = (type: string): JSX.Element => {
                    const normalizedType = type.toLowerCase().replace(/_/g, ' ');
                    if (normalizedType.includes('verified')) {
                      return <CheckCircleOutlineIcon sx={{ fontSize: 18, color: '#00CFA1' }} />;
                    }
                    if (normalizedType.includes('status')) {
                      return <SwapHorizIcon sx={{ fontSize: 18, color: '#F59E0B' }} />;
                    }
                    if (normalizedType.includes('note')) {
                      return <CommentIcon sx={{ fontSize: 18, color: '#8B5CF6' }} />;
                    }
                    if (
                      normalizedType.includes('trigger')
                      || normalizedType.includes('unit suite')
                      || normalizedType.includes('notice period')
                      || normalizedType.includes('rate structure')
                      || normalizedType.includes('sf updated')
                      || normalizedType.includes('lease expiration')
                    ) {
                      return <EditIcon sx={{ fontSize: 18, color: '#3B82F6' }} />;
                    }
                    return <HistoryIcon sx={{ fontSize: 18, color: '#6B7280' }} />;
                  };

                  const getActivityDescription = (): string => {
                    const normalizedType = activityType.toLowerCase().replace(/_/g, ' ');
                    if (normalizedType.includes('status')) {
                      if (activity.old_status && activity.new_status) {
                        const oldDisplay = activity.old_status.charAt(0).toUpperCase() + activity.old_status.slice(1);
                        const newDisplay = activity.new_status.charAt(0).toUpperCase() + activity.new_status.slice(1);
                        return `Changed status: ${oldDisplay} → ${newDisplay}`;
                      }
                      return activity.details || 'Changed status';
                    }
                    if (normalizedType.includes('verified')) {
                      return 'Verified option details';
                    }
                    if (normalizedType.includes('note added')) {
                      return 'Added a note';
                    }
                    if (normalizedType.includes('note updated')) {
                      return 'Updated the note';
                    }
                    if (normalizedType.includes('trigger')) {
                      return 'Updated trigger event';
                    }
                    if (normalizedType.includes('unit suite')) {
                      return 'Updated unit / suite';
                    }
                    if (normalizedType.includes('notice period')) {
                      return 'Updated notice period';
                    }
                    if (normalizedType.includes('rate structure')) {
                      return 'Updated rate structure';
                    }
                    if (normalizedType.includes('sf updated')) {
                      return 'Updated SF';
                    }
                    if (normalizedType.includes('lease expiration')) {
                      return 'Updated lease expiration date';
                    }
                    return activity.details || activityType.replace(/_/g, ' ');
                  };

                  return (
                    <div className='activity-row' key={`activity-${activity.timestamp}-${index.toString()}`}>
                      <div className='activity-icon'>
                        {getActivityIcon(activityType)}
                      </div>
                      <div className='activity-content'>
                        <div className='activity-info'>
                          <span className='activity-user'>{userName}</span>
                          <span className='activity-dot'>·</span>
                          <span className='activity-date'>
                            {new Date(activity.timestamp).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                          </span>
                        </div>
                        <div className='activity-description'>
                          {getActivityDescription()}
                        </div>
                        {activity.note && (
                          <div className='activity-note'>
                            &quot;{activity.note}&quot;
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </TabPanel>

      {/* Tab 2: Full Lease Abstraction */}
      <TabPanel value={tabValue} index={1}>
        <LeaseAbstractionTab leaseId={item.lease_id} />
      </TabPanel>

      {/* Tab 3: Amendments */}
      <TabPanel value={tabValue} index={2}>
        <AmendmentAbstractionTab leaseId={item.lease_id} />
      </TabPanel>

      {/* Footer Buttons */}
      <div className='sidesheet-footer-buttons'>
        {currentStatus === 'Active' ? (
          <>
            <Button
              variant='outlined'
              onClick={handleMarkAsWaived}
              sx={{
                borderColor: '#E5E7EB',
                color: '#212121',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 500,
                borderRadius: '6px',
                padding: '6px 14px',
                height: '35px',
                '&:hover': { borderColor: '#9CA3AF', backgroundColor: '#F9FAFB' },
              }}
            >
              Mark as Waived
            </Button>
            <Button
              variant='outlined'
              onClick={handleMarkAsExercised}
              sx={{
                borderColor: '#E5E7EB',
                color: '#212121',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 500,
                borderRadius: '6px',
                padding: '6px 14px',
                height: '35px',
                '&:hover': { borderColor: '#9CA3AF', backgroundColor: '#F9FAFB' },
              }}
            >
              Mark as Exercised
            </Button>
          </>
        ) : (
          <Button
            variant='outlined'
            onClick={(): void => handleStatusChange('Active')}
            sx={{
              borderColor: '#E5E7EB',
              color: '#212121',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500,
              borderRadius: '6px',
              padding: '6px 14px',
              height: '35px',
              '&:hover': { borderColor: '#9CA3AF', backgroundColor: '#F9FAFB' },
            }}
          >
            Reactivate
          </Button>
        )}
        <div style={{ flex: 1 }} />
        <Button
          variant='outlined'
          onClick={handleViewLease}
          sx={{
            borderColor: '#E5E7EB',
            color: '#212121',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            borderRadius: '6px',
            padding: '6px 14px',
            height: '35px',
            '&:hover': { borderColor: '#9CA3AF', backgroundColor: '#F9FAFB' },
          }}
        >
          View Lease
        </Button>
        <Button
          variant='contained'
          onClick={onClose}
          sx={{
            backgroundColor: '#00CFA1',
            color: '#fff',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            borderRadius: '6px',
            padding: '6px 18px',
            height: '35px',
            boxShadow: 'none',
            '&:hover': { backgroundColor: '#00B890', boxShadow: 'none' },
          }}
        >
          Done
        </Button>
      </div>
    </Paper>
  );
}
